import request, { formatRequest } from "@/utils/request"

import { IReturnData, storeMenuListProps, storeProductsListProps } from "./type"

const APIReturnPage = {
  getConfig() {
    return request.get("/v1/returnPageSetting")
  },
  setConfig(config) {
    return request.post("/v1/returnPageSetting", { config })
  },

  getReturnConfig(params?: any) {
    return request.get("/v1/returnPageSetting", { params })
  },
  getFontList() {
    return request.get("/v1/getFontList")
  },
  /**
   * @param {number} id  配置id值
   * @param {Omit<IReturnData, 'id'>} config 更新的配置项
   */
  updateReturnConfig(
    id: number,
    config: Omit<IReturnData, "id" | "eventStatus">,
  ) {
    return request.put(`/v1/returnPageSetting/${id}`, {
      text: config.text,
      style: config.style,
      is_remove_brand: config.is_remove_brand,
      code: config.code,
      store_contact_info: config.store_contact_info,
    })
  },

  /**
   * @description 获取oss直传密钥等参数
   */
  getUploadKey() {
    return request.get("/v1/getUploadKey")
  },

  validateUploadKey(params: { url: string }) {
    return formatRequest(
      request.get("/go-api/v1/com/callback", {
        params,
      }),
      {
        error: {
          "*": "Upload failed",
        },
      },
    )
  },
  /**
   * @description 获取oss直传密钥等参数
   */
  getUploadKeyV2(params) {
    return request.get("/go-api/v1/com/getUploadKey", {
      params,
    })
  },

  /**
   * @description 第一次进入demo店铺发送请求通知后端
   */
  updateEnterStatus() {
    return request.get("/v1/enterTestStore")
  },

  getReturnPageUrl() {
    return request.get("/go-api/v1/setting/getReturnPageUrl")
  },

  setReturnPageUrl(config) {
    return request.post("/go-api/v1/setting/updateReturnPageUrl", config)
  },

  // 获取店铺产品分类菜单列表 (全部)
  getStoreMenuList(config: storeMenuListProps) {
    return formatRequest(request.post("/go-api/v1/page/collections", config))
  },

  // 【return page】获取店铺产品集合分类【新版】
  getNetStoreMenuList(config: storeMenuListProps) {
    return formatRequest(
      request.post("/go-api/v1/page/collections/list", config),
    )
  },

  // 获取店铺产品按集合分类
  getStoreProductsList(config: storeProductsListProps) {
    return formatRequest(
      request.post("/go-api/v1/page/collection/products", config),
    )
  },
  // 获取店铺产品按集合分类
  updateRemoveBrand(params) {
    return formatRequest(
      request.post("/go-api/v1/setting/updateRemoveBrand", params),
    )
  },
}

export default APIReturnPage
